<div *ngIf="visibility" class="cand-modal">
    <article [@slideInOut] class="cand-modal__overlay" [ngClass]="{ 'cand-modal__overlay--centered': centered }">
        <h1 class="cand-modal__title">{{ modalTitle | i18n }}</h1>
        <section class="cand-modal__content cand-modal__content--error">
            <p class="cand-modal__message">
                <span *ngIf="icon" [ngClass]="icon"></span>
                <span class="cand-modal__messageText" [ngClass]="{ centered: centered }" [innerHTML]="content | i18n"></span>
            </p>
        </section>
        <button *ngIf="centered" class="button button--primary" (click)="close()">{{ closeButton | i18n }}</button>

        <footer *ngIf="!centered" class="recovery-form__footer">
            <button class="button button--primary" type="button" (click)="close()">{{ closeButton | i18n }}</button>
        </footer>
    </article>
    <div [@fadeInOut] class="cand-modal__fade" (click)="close()"></div>
</div>
